/**
 * Rotation Dept — Cart Drawer Enhancements
 * Adds: "Your Rotation" heading, shipping progress bar, item count subline
 */

(function() {
  const FREE_SHIPPING_THRESHOLD = 7500; // £75.00 in pence

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function buildProgressBar(cartTotal) {
    // Defensive: treat undefined/NaN as 0 so we never render '£NaN'
    const safeTotal = (typeof cartTotal === 'number' && !isNaN(cartTotal)) ? cartTotal : 0;
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - safeTotal);
    const pct = Math.min(100, (safeTotal / FREE_SHIPPING_THRESHOLD) * 100);
    const qualified = safeTotal >= FREE_SHIPPING_THRESHOLD;

    return `
      <div class="rd-shipping-bar">
        <div class="rd-shipping-bar__labels">
          <span class="rd-shipping-bar__label">SHIPPING PROGRESS</span>
          <span class="rd-shipping-bar__amount">
            ${qualified ? 'FREE SHIPPING UNLOCKED' : formatMoney(remaining) + ' AWAY FROM FREE SHIPPING'}
          </span>
        </div>
        <div class="rd-shipping-bar__track">
          <div class="rd-shipping-bar__fill" style="width: ${pct}%"></div>
        </div>
      </div>
    `;
  }

  // ── Debounce injection to prevent cart-qty change flicker ──
  // MutationObserver and cart:updated can fire 5-10x rapidly during a
  // single qty change. Without this, each fires two /cart.js fetches
  // and re-injects the bar + count, causing visible flicker.
  let __rdCartInjectTimer;
  function __rdDebouncedInject() {
    clearTimeout(__rdCartInjectTimer);
    __rdCartInjectTimer = setTimeout(injectCartEnhancements, 150);
  }

  function injectCartEnhancements() {
    const drawer = document.querySelector('.cart-drawer__dialog, cart-drawer-component, [id="cart-drawer"]');
    if (!drawer) return;

    // ── 1. Change heading text ──
    const heading = drawer.querySelector('.cart-drawer__heading, [class*="cart-drawer__title"]');
    if (heading && !heading.dataset.rdPatched) {
      heading.textContent = 'YOUR ROTATION';
      heading.dataset.rdPatched = 'true';
    }

    // ── 2. Add item count subline ──
    const headingParent = heading ? heading.parentElement : null;
    if (headingParent && !headingParent.querySelector('.rd-item-count')) {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          // Defensive: bail if cart malformed / empty — native UI handles empty state
          if (!cart || typeof cart.item_count !== 'number') return;
          if (cart.item_count === 0) return;
          const count = cart.item_count;
          const sub = document.createElement('span');
          sub.className = 'rd-item-count';
          sub.textContent = count + (count === 1 ? ' ITEM' : ' ITEMS') + ' SELECTED';
          headingParent.appendChild(sub);
        })
        .catch(() => { /* silently skip on network error */ });
    }

    // ── 3. Inject shipping progress bar ──
    const header = drawer.querySelector('.cart-drawer__header');
    if (header && !header.querySelector('.rd-shipping-bar')) {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          // Defensive: bail if cart malformed / empty
          if (!cart || typeof cart.total_price !== 'number') return;
          if (cart.item_count === 0) return;
          const bar = document.createElement('div');
          bar.innerHTML = buildProgressBar(cart.total_price);
          header.insertAdjacentElement('afterend', bar.firstElementChild);
        })
        .catch(() => { /* silently skip on network error */ });
    }
  }

  // Watch for drawer opening (Horizon uses a custom element / class toggle)
  const observer = new MutationObserver(() => {
    const isOpen =
      document.querySelector('.cart-drawer__dialog[open]') ||
      document.querySelector('cart-drawer-component[open]') ||
      document.querySelector('[data-cart-drawer].is-open') ||
      document.querySelector('.cart-drawer--open');
    if (isOpen) __rdDebouncedInject();
  });

  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'class'] });

  // Also run on page load in case drawer starts open
  document.addEventListener('DOMContentLoaded', __rdDebouncedInject);

  // Re-run when cart is updated (Shopify dispatches this)
  document.addEventListener('cart:updated', () => {
    const bar = document.querySelector('.rd-shipping-bar');
    if (bar) bar.remove();
    const count = document.querySelector('.rd-item-count');
    if (count) count.remove();
    __rdDebouncedInject();
  });
})();
